module.exports = "<div class=row ng-repeat=\"row in vm.data\"> <h4 ng-bind=row.title></h4> <p ng-bind=row.content></p> </div> ";